/**
 * 设置财务信息
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Radio, Input } from 'antd';
import { XOKButton, XCancelButton, XMediaFn } from '@/components/xqxc_ui';
import model from '@/reducers/audit/picturenickname/model';

const { TextArea } = Input;

const EDModal = ({
    closeModal,
    modalParams: {
        title = '',
        id = '',
        type = ''
    } = {},
    getPicturenicknameInfo,
    picturenicknameInfo: {
        phone = '',
        auditTypeDesc = '',
        userTypeDesc = '',
        auditType = '',
        relateValue = '',
        auditStateDesc = '',
        auditOpinion = '',
        auditState = ''
    } = {}
}) => {

    const [loading, setLoading] = useState(false);
    const [auditStatus, setAuditStatus] = useState('PASS_AUDIT');
    const [auditReason, setAuditReason] = useState('');

    useEffect(() => {
        getPicturenicknameInfo({ id })
    }, []);

    const onSubmit = () => {
        if (auditStatus === 'FAIL_AUDIT' && !auditReason) {
            message.warn('请输入不通过原因');
            return;
        }
        setLoading(true);
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.AvatarNicknameAuditMisService.audit', { auditOpinion: auditReason, id, auditState: auditStatus }, 'POST')
            .then(() => {
                message.success('审核操作成功');
                setLoading(false);
                closeModal(true);
            })
            .catch(error => {
                setLoading(false);
                message.error(error.message);
            });
    };

    const footerNode = <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {
            type === 'audit' && <XCancelButton
                style={{ width: '65px', marginRight: '20px' }}
                label='取消'
                onClick={() => closeModal(false)}
            />
        }
        <XOKButton
            style={{ width: '65px' }}
            label='确认'
            onClick={type === 'audit' ? onSubmit : () => closeModal(false)}
        />
    </div>;

    return <Modal
        width={500}
        centered
        title={title}
        visible={true}
        confirmLoading={loading}
        onCancel={() => closeModal(false)}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        footer={footerNode}
    >
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.component}>
                    <div className={styles.label}>会员账号：</div>
                    <div className={styles.text}>{phone}</div>
                </div>
                <div className={styles.component}>
                    <div className={styles.label}>审核类型：</div>
                    <div className={styles.text}>{auditTypeDesc}</div>
                </div>
            </div>
            <div className={styles.inner}>
                <div className={styles.component}>
                    <div className={styles.label}>审核信息：</div>
                    {
                        auditType === 'NICKNAME' ?
                            <div className={styles.text}>
                                {relateValue}
                            </div> :
                            <div className={styles.text}>
                                <XMediaFn dataSource={relateValue} />
                            </div>
                    }
                </div>
                <div className={styles.component}>
                    <div className={styles.label}>会员身份：</div>
                    <div className={styles.text}>{userTypeDesc}</div>
                </div>
            </div>
            <div className={styles.inner}>
                <div className={styles.auditState}>
                    <div className={styles.label}>审核状态：</div>
                    {
                        type === 'audit' ?
                            <div className={styles.content}>
                                <Radio.Group value={auditStatus} onChange={e => setAuditStatus(e.target.value)}>
                                    <Radio key='PASS_AUDIT' value='PASS_AUDIT'>通过</Radio>
                                    <Radio key='FAIL_AUDIT' value='FAIL_AUDIT'>不通过</Radio>
                                </Radio.Group>
                                {
                                    auditStatus === 'FAIL_AUDIT' &&
                                    <TextArea
                                        style={{ marginTop: '20px' }}
                                        value={auditReason}
                                        onChange={e => setAuditReason(e.target.value)}
                                        placeholder='请输入不通过原因'
                                        autoSize={{ minRows: 3, maxRows: 5 }}
                                    />
                                }
                            </div> :
                            <div className={styles.text}>{auditStateDesc}</div>
                    }
                </div>
            </div>
            {
                type === 'detail' && auditState === 'FAIL_AUDIT' &&
                <div className={styles.inner} style={{ marginTop: '20px' }}>
                    <div className={styles.component}>
                        <div className={styles.label}>原因：</div>
                        <div className={styles.text}>{auditOpinion}</div>
                    </div>
                </div>
            }
        </div>
    </Modal>;
};
EDModal.propTypes = {
    closeModal: PropTypes.func,
    modalParams: PropTypes.object,
    getPicturenicknameInfo: PropTypes.func,
    picturenicknameInfo: PropTypes.object,
};
export default connect(state => ({
    picturenicknameInfo: state.picturenickname.picturenicknameInfo,
}), model.actions)(EDModal);
